import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_mst_entity_e_consent_request_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  txn_reference: fromDatatype.VarcharDatatypeInterface;
  fund_source: fromDatatype.VarcharDatatypeInterface;
  effective_date: fromDatatype.TimestampTzDatatypeInterface;
  expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  max_amount: number;
  collection_amount: number;
  duitnow_status: fromDatatype.VarcharDatatypeInterface;
  duitnow_reason: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: any;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_mst_entity_e_consent_request_RowClass
  implements bl_fi_mst_entity_e_consent_request_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  txn_reference: fromDatatype.VarcharDatatypeInterface;
  fund_source: fromDatatype.VarcharDatatypeInterface;
  effective_date: fromDatatype.TimestampTzDatatypeInterface;
  expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  max_amount: number;
  collection_amount: number;
  duitnow_status: fromDatatype.VarcharDatatypeInterface;
  duitnow_reason: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: any;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
